import React, {FormEvent} from "react";
import {IItemContent} from "../../typescript-library";
import {useTranslation} from "react-i18next";
import styles from "./HeaderSearch.module.scss";
import genericStyles from "../lib/GenericStyles.module.scss";

const SuggestResultItem: React.FC<{item: IItemContent; onClick: (event: FormEvent) => void}> = ({item, onClick}) => {
  const {t} = useTranslation();
  const {title, url, itemId, prices, images} = item;
  const {advertise, price, retail} = (prices || []).find((prc) => prc.quantity.from === 1) || {};
  const squareFree = (images || []).find((image) => image.mediaTypeId === 100016);
  const thumbnailImage = squareFree?.sizes.find((size) => size.name === "thumbnail-2x")?.url || images[0].sizes[6]?.url; // thumbnail-3x image as fallback
  const thumbnailImage2x =
    squareFree?.sizes.find((size) => size.name === "half-2x")?.url || images[0].sizes[4]?.url || thumbnailImage; // half-3x image as fallback

  return (
    <a
      key={itemId}
      href={url}
      onClick={onClick}
      title={t("general.open--title", {title})}
      className={styles.suggestItem}
    >
      <div className={styles.suggestItemImage}>
        {thumbnailImage && (
          <img
            src={thumbnailImage}
            srcSet={`${thumbnailImage} 1x, ${thumbnailImage2x} 2x`}
            alt={title}
            loading="lazy"
            width="48"
            height="48"
          />
        )}
      </div>
      <div className={styles.suggestItemContent}>
        <span className={styles.suggestItemContentTitle}>{title}</span>
        <span>
          {advertise && (
            <>
              <s>{t("general.rrp--price", {price: retail?.formatted})}</s>{" "}
            </>
          )}
          <span className={advertise ? "red" : ""}>{price?.formatted}</span>
          <sup className={genericStyles.footnoteReference}>*</sup>
        </span>
      </div>
      <div className={styles.suggestItemIcon}>
        <i className="icon icon-right icon-size--22" />
      </div>
    </a>
  );
};

export default SuggestResultItem;
